//批量下载
import { contractApi } from "@/axios";
//下载信息提交
export function putBatchDownloads(data,key) {
    return contractApi({
        url: '/batch-downloads/download-batch/' + key,
        method: 'post',
        data: data
    })
}
//下载文件
export function batchDownloads(key) {
    return contractApi({
        url: '/batch-downloads/download-batch/' + key,
        method: 'get'
    })
}
